import { AssignWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Assign')
export class AssignNodeConnectorProvider extends ConnectorProvider<AssignWorkflowNode> {}
